export default function TicTacToeIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true" fill="none" strokeLinecap="round">
      <path d="M24 8v48M40 8v48M8 24h48M8 40h48" stroke="#3B434F" strokeWidth="4" />
      <path d="M10 10l9 9M19 10l-9 9" stroke="#2F8BFF" strokeWidth="5" />
      <path d="M28 28l8 8M36 28l-8 8" stroke="#2F8BFF" strokeWidth="5" />
      <circle cx="48" cy="48" r="5.5" stroke="#FF8A1F" strokeWidth="5" />
      <circle cx="48" cy="16" r="5.5" stroke="#FF8A1F" strokeWidth="5" />
    </svg>
  );
}
